import { useState } from 'react'
import { StyleSheet } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B5, colors, Icon, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { AnimatedNumber } from '@zet/feature-loyalty/screens/tierBenefits/animatedNumber'
import { currencyFormatConvertorRoundDown } from '@zet/feature-loyalty/utils'

import RupeeCircleFilled from '../../assets/svg/rupeeCircleFilled.svg'
import { i18n } from '../../localization'

type EarningWidgetProps = {
  pendingEarning?: number
  totalEarning?: number
}

const EarningWidget = ({
  pendingEarning,
  totalEarning,
}: EarningWidgetProps) => {
  const { navigate } = useNavigation()
  const [isVisibleAmount, setIsVisibleAmount] = useState(true)

  const handlePress = () => {
    navigate('Earnings')
    publishEvent('click_action', {
      item_name: 'homepage_earnings',
      feature: 'earnings',
    })
  }

  const getEarningsSubHeading = () => {
    if (pendingEarning && pendingEarning !== totalEarning) {
      return i18n.t('loyaltyDetails.pendingEarnings', {
        amount: isVisibleAmount
          ? `₹${currencyFormatConvertorRoundDown(pendingEarning?.toFixed(0))}`
          : 'XXX',
      })
    } else {
      return i18n.t('loyaltyDetails.totalEarnings')
    }
  }

  const handleToggle = (event) => {
    setIsVisibleAmount(!isVisibleAmount)
    event.preventDefault()
  }

  return (
    <PressableWithIntent
      name="EarningsCard"
      className={`flex-col rounded-lg p-3`}
      style={styles.card}
      onPress={handlePress}
    >
      <XStack className="items-center justify-between">
        <XStack className="mb-1 items-center">
          <RupeeCircleFilled />
          <AnimatedNumber
            animateToNumber={currencyFormatConvertorRoundDown(
              totalEarning?.toFixed(0)
            )}
            isVisibleAmount={isVisibleAmount}
          />
        </XStack>
        <Stack className="mx-2 justify-center">
          <Pressable
            onPress={handleToggle}
            eventName="click_action"
            eventPayload={{ item_name: 'eye_icon' }}
          >
            <Icon
              type={isVisibleAmount ? 'Show' : 'Hide'}
              color={colors.grays[60]}
            />
          </Pressable>
        </Stack>
      </XStack>
      <B5 className="text-grays-70 ml-1">{getEarningsSubHeading()}</B5>
    </PressableWithIntent>
  )
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#F3F7FE',
    width: '48%',
  },
})

export { EarningWidget }
